export const SEARCH_BACK_STORAGE_KEY = 'inCourseSearchReturnLink';
